<template>
  <div class="targetField22" v-loading="saveLoading" element-loading-text="正在加载中">
    <div class="th">
      <span>字段名</span>
      <span>操作</span>
    </div>
    <el-collapse v-model="collapseName" accordion @change="handleChange">
      <el-collapse-item v-for="(item,index) in testResult" :name=index+1 :key="index">
        <template slot="title">
          <div class="row">
            <changeFiledName :tname="item[1].fieldRuleList[0].title" :tcode="item[1].fieldRuleList[0].name"
              :tkey="item[0]" @on-success="changeSuccess"></changeFiledName>
            <div class="config">
              <a href="javascript:void(0)" @click="editRuleHandle(item,index)"
                v-if="$route.query.status === 'true'">查看规则</a>
              <a href="javascript:void(0)" @click="editRuleHandle(item)" v-if="$route.query.status !== 'true'">编辑规则</a>
              <a href="javascript:void(0)" @click.stop="deleteRule(item)" v-if="$route.query.status !== 'true'"
                class="delete">删除</a>
            </div>
          </div>
        </template>
        <div class="result">
          <div class="h2Title" @click="openHuoQu(item)">
            <h2 class="name" :id="currentArray[0]+'_1'"><span></span>值的获取配置</h2>
            <i class="el-icon-arrow-down" :class="{'is-revese':item[3]._huoqu}"></i>
          </div>
          <!-- 字段值获取配置 多个tabs -->
          <template v-if="item[3]._huoqu">
            <div class="addRuleButton" v-if="$route.query.status !== 'true'" ref="addRuleButtonRef">
              <el-button type="add" size="small" @click="addTab(item,index)">
                +添加规则
              </el-button>
            </div>
            <el-tabs class="tabsEditRule" v-model="item[2]._editableTabsValue" type="card" closable
              @tab-remove="removeTab(item,index,$event)" @tab-click="tabClick(item,$event)">
              <el-tab-pane v-for="(x, tabIndex) in item[2]._editableTabs" :key="item[0]+x.name" :label="x.title"
                :name="x.name">
                <span slot="label">{{x.title}}
                  <!-- 优先级设置 -->
                  <template v-if="tabIndex===0">
                    <span class="level">
                      {{transPrior(item[1]['fieldRuleList'][tabIndex].priority)}}
                    </span>
                  </template>
                  <template v-else>
                    <el-dropdown trigger="click" @command="commandDrop(item,tabIndex,$event)">
                      <span class="el-dropdown-link">
                        {{transPrior(item[1]['fieldRuleList'][tabIndex].priority)}}<i
                          class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="HIGH">高级</el-dropdown-item>
                        <el-dropdown-item command="MEDIUM">中级</el-dropdown-item>
                        <el-dropdown-item command="LOW">低级</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </span>
                <keep-alive>
                  <editRuleBox v-if="item[3]._edited" :currentArray='item' :index="index" :tabIndex="tabIndex"
                    :onlyRead="$route.query.status === 'true'" ref="editRuleBoxM"></editRuleBox>
                </keep-alive>
              </el-tab-pane>
            </el-tabs>
          </template>
          <!-- 字段值筛选配置 单个结果 -->
          <div class="h2Title" style="border-top: 1px solid rgba(61,127,255,0.30);" @click="openShaiXuan(item)">
            <h2 class="name" :id="currentArray[0]+'_2'"><span></span>值的筛选配置</h2>
            <i class="el-icon-arrow-down" :class="{'is-revese':item[3]._shaixuan}"></i>
          </div>
          <keep-alive>
            <template v-if="item[3]._shaixuan">
              <!-- tabIndex写的是固定值0，筛选配置验证错误都放到第一个tab里 -->
              <editFilterRuleBox v-if="item[3]._edited" :currentArray='item' :index="index" :tabIndex="0"
                :onlyRead="$route.query.status === 'true'" ref="editFilterRuleBox"></editFilterRuleBox>
            </template>
          </keep-alive>
          <div class="savefooter">
            <div class="el-button--save" @click="saveDialog(item,index)" style="margin-right:10px;">
              <span v-if="count === 1">保存并测试</span>
              <span v-if="count > 1">重新测试</span>
            </div>
            <el-button type="doc" @click.stop="configNext(item,index)"
              v-if="$route.query.status !== 'true' && count > 1">配置下一项</el-button>
          </div>
          <saveResult v-if="item[3]._testShow" :newlpItem="item[3]" :index="index" @on-close="closeTest">
          </saveResult>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 抽屉组件 -->
    <Drawer></Drawer>
  </div>
</template>
<script>
  import Vue from 'vue'

  import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
  } from 'vuex'

  import _ from 'lodash'

  import bus from '@/assets/js/bus'
  import busType from '@/assets/js/busType'

  import editRuleBox from '../common/editRuleBox'
  import editFilterRuleBox from '../common/editFilterRuleBox'
  import saveResult from '../common/saveResult'
  import changeFiledName from '../common/changeFiledName'
  import Drawer from '../common/Drawer'
  import drawRedRect from '@/assets/js/mixin/drawRedRect'

  export default {
    name: 'targetField',
    mixins: [drawRedRect],
    props: {
      mainInfo: Array,
      pane: String,
      switchValue: Boolean
    },
    data() {
      return {
        visibility: false,
        currentArray: [],
        collapseName: '0',
        testResult: [],
        currentItem: {},
        saveLoading: false,
        count: 1,
        // delshow:''
      };
    },
    computed: {
      ...mapState(['labelState']),
      ...mapGetters(['editTemplate', 'ocrResults', 'currentImage', 'groupList']),
      // delgroupList(){
      //   return this.$store.state.labelState.groupList
      // },
    },
    components: {
      editRuleBox,
      editFilterRuleBox,
      saveResult,
      changeFiledName,
      Drawer
    },
    watch: {
      mainInfo(val) {
        this.initAttr();
      },
      'ocrResults': {
        handler: function (val, oldVal) { },
        deep: true
      }
    },
    created() {
      this.initAttr();

      this.$nextTick(() => {
        //读缓存折叠记录数
        let num = this.$utils.storage('BL_ORIGIN_TEMPLATE_COLLAPSE');

        if (num && this.testResult[num - 1] && this.$route.query.status !== 'true') {
          this.testResult[num - 1][3]._edited = true;
          this.currentArray = this.testResult[num - 1];

          // TEMPLATE-614 更换测试模板后，默认打开的配置项无内容 出bug
          // this.collapseName = num;
        }
        this.changeButtonPosition(this.currentArray, num - 1);
      })

      this.scrollOut();
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
      transIndex(x) {
        return parseInt(x) - 1;
      },
      initAttr() {
        this.testResult = _.cloneDeep(this.mainInfo);
        return;
      },
      scrollOut() {
        //当上下滚动时才展示，不上下滚动则不展示

        this.topValue = 0, // 上次滚动条到顶部的距离
          this.interval = null; // 定时器

        let outerScroll = document.querySelector('.editTexts');
        let target = document.querySelector('.editTexts .target');
        if (!target) {
          return
        }
        target.style.paddingBottom = outerScroll.clientHeight - 57 + 'px'

        if (outerScroll) {
          outerScroll.onscroll = () => {
            // 未发起时，启动定时器，1秒1执行
            if (this.interval == null) {
              this.interval = setInterval(this.clearRoll, 1000);
            }
            outerScroll.classList.add('roll');
            this.topValue = outerScroll.scrollTop;

            this.$utils.fakeClickOutSide();
          }
        }
      },
      clearRoll() {
        let outerScroll = document.querySelector('.editTexts');

        // 判断此刻到顶部的距离是否和1秒前的距离相等
        if (outerScroll && outerScroll.scrollTop == this.topValue) {
          outerScroll.classList.remove('roll');
          clearInterval(this.interval);
          this.interval = null;
        }
      },
      handleChange(x) {
        if (typeof x === 'number') {
          this.count = 1;
          // 打开toggle
          let item = this.testResult[x - 1];

          item[3]._edited = true;

          this.currentArray = item;

          this.changeButtonPosition(this.currentArray, x - 1);

          //存储
          this.$utils.storage('BL_ORIGIN_TEMPLATE_COLLAPSE', x);

          // 打开滚动条上滑，吸顶
          // 滚动依赖最外层dom
          let dom = document.querySelector('.editTexts');

          // 依赖components/common/changeFiledName.vue 定义class为'fieldTitle'的dom
          let keys = dom.getElementsByClassName('fieldTitle');
          if (keys.length > 0 && keys[x - 1]) {
            let value = keys[x - 1].parentElement.offsetTop + 35;
            dom.scroll(0, value);
          }

          // 画框
          if (this.ocrResults) {
            this.drawRec(this.currentArray);
          }
        } else {
          this.currentArray[3]._edited = false;

          // this.clearCanvas();
        }


      },
      editRuleHandle(item) {
        item[3]._edited = true;
        this.currentArray = item;
      },
      closeName() {
        // 关闭激活的面板
        this.collapseName = [];
      },
      deleteRule(item) {
        this.$emit('on-delete', item);
      },
      configNext(item, index) {
        // 自动收起当前配置，自动展开下一项配置
        let next = index + 1;
        if (this.testResult[next]) {
          ++this.collapseName;

          this.testResult[next][3]._edited = true;

          this.currentArray = this.testResult[next];

          // 滚动调整
          this.$nextTick(() => {
            // 滚动依赖最外层dom
            let dom = document.querySelector('.editTexts');

            // 依赖components/common/changeFiledName.vue 定义class为'fieldTitle'的dom
            let keys = dom.getElementsByClassName('fieldTitle');
            if (keys.length > 0 && keys[next]) {
              let value = keys[next].parentElement.offsetTop + 35;
              dom.scroll(0, value);
            }

          })

          this.$utils.storage('BL_ORIGIN_TEMPLATE_COLLAPSE', next + 1);
        }

      },
      saveDialog(item, index, type) {

        // 校验多个tabs
        if (type === 'save' || type === 'remove') {
          item[2]['_editableTabs'].forEach(x => {
            x['validator'] = true;
          })
        }
        // item['_editableTabs'].forEach(item => {
        //     item['validator'] = true;
        // })

        let bl = true;
        item[2]['_editableTabs'].forEach(x => {
          if (x['validator'] === false) {
            bl = false;
          }
        })

        if (bl === false) {
          this.$message.error('校验未通过');
          return;
        }

        this.count++;

        this.saveLoading = true;

        // let fieldRuleList
        // this.$refs.editRuleBoxM.forEach(component => {
        //     if (component.currentArray[0] === item[0]) {
        //         fieldRuleList = component.form;
        //     }
        // })
        // let fieldFilterRule;
        // this.$refs.editFilterRuleBox.forEach(component => {
        //     if (component.currentArray[0] === item[0]) {
        //         fieldFilterRule = component.form;
        //     }
        // })

        let url = this.$resource.editTemplate
          .replace('{templateId}', this.editTemplate.templateId)

        this.$axios({
          url: url,
          method: 'put',
          data: [{
            fieldRuleList: item[1].fieldRuleList,
            fieldFilterRule: item[1].fieldFilterRule,
            addField: false
          }]
        }).then(res => {

          let filds = {
            keywordFormatSet: '字段名关键字的格式',
            regexpValueFormatSet: '字段值的格式',
            valueFormatSet: '字段值必须包含的格式',
            valueNoFormatSet: '字段值不能包含的格式'
          }
          if (res.data.code === 0) {
            //保存校验
            let d = JSON.parse(res.data.data.msg);

            let str = '';
            let ary = Object.keys(d);

            ary.forEach(item => {
              let o = Object.entries(d[item]);
              str += '字段名：' + item;
              o.forEach((x) => {
                str += '<br/>字段项：' + filds[x[0]] + '<br/> 正则表达式：<em>' + x[1] + '</em>有错误';
              })

            })

            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              duration: '6000',
              customClass: 'regClass',
              message: str
            });
            this.saveLoading = false;
            return;
          }
          if (res.data.code !== 0) {
            // this.$message.success('保存成功');

            // bus.$emit(busType.RESETINDENTITY);

            if (type === 'fix') {

              this.$message.success('优先级修改成功');

              this.saveLoading = false;
              return;
            }
            if (type === 'add') {

              this.$message.success('添加规则成功');

              this.saveLoading = false;
              return;
            }
            if (type === 'remove') {
              this.$message.success('规则删除成功');

              this.saveLoading = false;
              return;
            }
            this.testDialog(item, index);
          }

        }).catch(e => {
          this.saveLoading = false;
          console.log(e)
        })
      },
      testDialog(item, index) {
        item[3]._testShow = true;

        let url = this.$resource.testRule;

        let imagelist = this.editTemplate.imageList.map(x => {
          return x.resPath;
        })

        // let fieldRuleList
        // this.$refs.editRuleBoxM.forEach(component => {
        //     if (component.currentArray[0] === item[0]) {
        //         fieldRuleList = component.form;
        //     }
        // })
        // let fieldFilterRule;
        // if (this.$refs.editFilterRuleBox) {
        //     this.$refs.editFilterRuleBox.forEach(component => {
        //         if (component.currentArray[0] === item[0]) {
        //             fieldFilterRule = component.form;
        //         }
        //     })
        // }

        this.$axios({
          url: url,
          method: 'post',
          timeout: 1000 * 60 * 3,
          data: {
            category: this.editTemplate.subTypeRule.category,
            fieldRule: {
              fieldRuleList: item[1].fieldRuleList,
              fieldFilterRule: item[1].fieldFilterRule
            },
            imagePathList: imagelist,
            certiType: this.$route.query.certiType,
            oriFilePath: this.editTemplate.oriFilePath
          },
          transformResponse: [(data) => {
            // 对 data 进行任意转换处理
            let result = JSON.parse(data);

            this.compareText(result.data);

            this.setRectangleListGroup(result.data)
            return result;

          }]
        }).then(res => {
          this.saveLoading = false;

          let data = res.data.data;
          if (data.rectangle) {
            //单值
            item[3]._testWord = data.rectangle.words === '' ?
              '测试结果为空' : data.rectangle.words;
            item[3]._rectangleList = data.rectangle;
          } else {
            //多值
            if (data.rectangleList.length === 0) {
              item[3]._testWord = '测试结果为空';
              item[3]._rectangleList = data.rectangleList;
            } else {
              item[3]._rectangleList = data.rectangleList;
              item[3]._rectangleList.forEach(x => {
                x.forEach((y) => {
                  y.words = y.words === '' ?
                    '测试结果为空' : y.words;
                })
              })
              item[3]._testWord = '';
            }
          }
          item[3]._sourceData = data.sourceData;

          this.testResult.splice(index, 1, item);

          //保存完，异常滚动到底部
          let editScroll = this.$utils.storage('BL_ORIGIN_TEMPLATE_EDITTEXTSCROLL');
          let editTexts = document.querySelector('.editTexts');

          // setTimeout(() => {
          //     editTexts.scrollTop = editScroll;
          // }, 400)

          this.$message.success('保存并测试成功');
        }).catch(e => {
          this.saveLoading = false;
          console.log(e)
        })
      },
      format(sentence) {
        // 去掉回车信息
        let str = sentence.replace(/\n/g, '');
        return str;
      },
      compareText(data) {
        // 值的获取测试结果,与值的筛选测试结果做对比，比较出来的差异用黑色字体展示
        if (data.rectangle) {
          // 单值
          let words = this.format(data.rectangle.words);
          let source = data.sourceData;

          let ary = [];
          source.forEach(item => {
            let valueList = item.valueList;
            let newList = [];
            valueList.forEach(x => {
              if (x.includes(words) || this.format(x) === words) {
                newList.push(x)
              }
              if (!x.includes(words) && this.format(x) !== words) {
                x = '<em>' + x + '</em>';
                newList.push(x)
              }
            })
            item.valueList = newList;
            ary.push(item);
          })
          data.sourceData = ary;
        } else {
          // 1.把数组中的单词变成字符串
          let ary = [];
          data.rectangleList.forEach(item => {
            ary.push(item.words)
          })
          let str = ary.join('\n');

          // 2.跟sourceData中每项比较
          let source = data.sourceData;

          let newSource = []
          source.forEach(item => {
            let valueList = item.valueList;
            let newList = [];
            valueList.forEach(x => {
              if (!x.includes(str)) {
                newList.push('<em>' + x + '</em>');
              } else {
                let len = x.indexOf(str);
                let str1 = x.slice(0, len);
                let str2 = x.slice(len, len + str.length);
                let str3 = x.slice(len + str.length, x.length);
                newList.push('<em>' + str1 + '</em>' + str2 + '<em>' + str3 + '</em>');
              }
            })
            item.valueList = newList;
            newSource.push(item);
          })
          data.sourceData = newSource;
        }
      },
      groupBy(array, f) {
        const groups = {};
        array.forEach(function (o) {
          const group = JSON.stringify(f(o));
          groups[group] = groups[group] || [];
          groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
          return groups[group];
        });
      },
      setRectangleListGroup(data) {
        // rectangleList,分页分组处理
        if (data.rectangle) {
          return;
        } else {
          const sorted = this.$utils.groupBy(data.rectangleList, function (item) {
            return [item.pageId]; //按照pageId进行分组
          });
          data.rectangleList = sorted;
        }
      },
      closeTest(item, index) {
        item._testShow = false;
      },
      addTab(item, index) {

        if (item[2]._tablen >= 5) {
          this.$message.info('一个字段最多添加5个规则');
          return;
        }
        let tabList = item[1]['fieldRuleList'];

        let end = tabList.length - 1;

        let obj = _.cloneDeep(this.$utils.defaultRule);

        obj.title = tabList[end].title;
        obj.name = tabList[end].name;
        tabList.push(obj);


        let newTabName = ++item[2]._tablen + '';
        item[2]._editableTabs.push({
          title: '规则' + newTabName,
          name: newTabName,
          validator: true
        });
        item[2]._editableTabsValue = newTabName;

        this.saveDialog(item, '', 'add');

        this.changeButtonPosition(item, index);
      },
      removeTab(item, index, targetName) {
        // debugger;
        let tabList = item[1]['fieldRuleList'];
        if (tabList.length === 1) {
          this.$message.error('至少保留一个筛选规则');
          return;
        }
        let tabs = item[2]._editableTabs;

        let activeName = item[2]._editableTabsValue;

        let same = false;
        if (activeName === targetName) {

          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab === tabs[index + 1]) {
                same = true;
              } else {
                same = false;
              }
            }
          });

        } else {
          if (targetName > activeName) {
            same = false;
          } else {
            same = true;
          }
        }
        // debugger;
        item[2]._editableTabs = tabs.filter(tab => tab.name !== targetName);

        item[2]._editableTabs = item[2]._editableTabs.map((tab, index) => {
          if (index >= parseInt(targetName) - 1) {
            tab.title = '规则' + (index + 1);
            tab.name = '' + (index + 1);
          }
          return tab;
        });

        item[1]['fieldRuleList'].splice(parseInt(targetName) - 1, 1);

        if (same) {
          item[2]._editableTabsValue = targetName;

        } else {
          item[2]._editableTabsValue = targetName - 1 + '';
        }

        item[2]._tablen = item[1]['fieldRuleList'].length;

        this.saveDialog(item, '', 'remove');

        this.changeButtonPosition(item, index);
      },
      changeButtonPosition(item, index) {
        // 动态改变【添加规则】按钮的位置
        if (item && item[2] && item[2]._tablen) {
          let base = 151;
          let width = 121 * (item[2]._tablen - 1);
          if (this.$refs.addRuleButtonRef[index]) {
            this.$refs.addRuleButtonRef[index].style.left = base + width + 'px';
          }
        }

      },
      tabClick(item, event) {
        item[3]._edited = true;

        // 画框
        if (this.ocrResults) {
          this.drawRec(item);
        }
      },
      transPrior(x) {
        if (x === 'HIGH') {
          return '高级';
        } else if (x === 'MEDIUM') {
          return '中级';
        } else {
          return '低级';
        }
      },
      commandDrop(item, tabIndex, priority) {

        item[1]['fieldRuleList'][tabIndex].priority = priority;

        this.saveDialog(item, '', 'fix');
      },
      changeSuccess() {
        // http://jira.bailian-ai.com/browse/TEMPLATE-553
        // 字段值获取配置，修改字段名，配置列表内容被隐藏
        // 强制关闭
        this.closeName();

        this.$nextTick(() => {
          // 重新识别单证
          bus.$emit(busType.RESETINDENTITY);
        })
      },
      openHuoQu(item) {
        item[3]._huoqu = !item[3]._huoqu;
      },
      openShaiXuan(item) {
        item[3]._shaixuan = !item[3]._shaixuan;
      },

    }
  };
</script>
<style>
  @import './editcollapse.css';

  #clippingBounds .imageIdentify .contentBill .right .footer .el-button {
    padding: 0px;
  }
</style>